<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="18.5" :stroke="fill" stroke-width="3"/>
    <path d="M21 14.0005H19V12.0005C19 11.4482 19.4477 11.0005 20 11.0005V11.0005C20.5523 11.0005 21 11.4482 21 12.0005V14.0005Z" :fill="fill"/>
    <path d="M19 26.0005L21 26.0005L21 28.0005C21 28.5528 20.5523 29.0005 20 29.0005V29.0005C19.4477 29.0005 19 28.5528 19 28.0005L19 26.0005Z" :fill="fill"/>
    <path d="M22.3178 22.1991L22.3178 22.1991L22.3188 22.2018C22.3942 22.3967 22.4331 22.6247 22.4331 22.8877C22.4331 23.2503 22.3443 23.5592 22.1703 23.8186L22.1696 23.8197C22.0005 24.0787 21.7502 24.2808 21.4127 24.424C21.0756 24.5671 20.6587 24.6406 20.1588 24.6406C19.8144 24.6406 19.483 24.5989 19.1642 24.5158C18.8529 24.428 18.5743 24.2941 18.3277 24.1146C18.0884 23.9368 17.8993 23.7136 17.7601 23.4438C17.6226 23.1721 17.5518 22.8434 17.5518 22.4545V22.3545H17.4518H16H15.9V22.4545C15.9 23.0512 16.0214 23.5813 16.2672 24.0417L16.2672 24.0417L16.2678 24.043C16.5166 24.4938 16.846 24.8735 17.2556 25.1815L17.2561 25.1819C17.6687 25.4883 18.1251 25.718 18.6248 25.871L18.6251 25.8711C19.1283 26.0236 19.6397 26.1 20.1588 26.1C20.7467 26.1 21.2811 26.0268 21.761 25.879L21.7617 25.8788C22.2457 25.7258 22.663 25.5091 23.0118 25.2275C23.361 24.9455 23.6302 24.6047 23.8182 24.2057C24.0067 23.8059 24.1 23.3606 24.1 22.8717C24.1 22.4067 24.0253 21.9874 23.8736 21.6154C23.727 21.2379 23.4994 20.9027 23.1925 20.6101C22.8914 20.3128 22.5095 20.0479 22.049 19.8145C21.5888 19.5813 21.0436 19.3707 20.4143 19.1823L20.4139 19.1822C19.9632 19.0493 19.5768 18.9117 19.2542 18.7696C18.9376 18.6279 18.6786 18.4745 18.4754 18.3103C18.2778 18.1466 18.1341 17.973 18.0406 17.7902C17.9522 17.6019 17.9072 17.3925 17.9072 17.1604C17.9072 16.8123 17.9842 16.5064 18.1357 16.2399C18.2908 15.976 18.5268 15.7641 18.8494 15.6058C19.1692 15.4488 19.5813 15.3674 20.0907 15.3674C20.6289 15.3674 21.0645 15.4643 21.4034 15.6517L21.4034 15.6517L21.4044 15.6522C21.7456 15.8357 21.9978 16.0889 22.1644 16.4121L22.1647 16.4127C22.3326 16.7332 22.418 17.1046 22.418 17.5294V17.6294H22.518H23.9698H24.0698V17.5294C24.0698 16.9025 23.914 16.3134 23.6032 15.7638C23.2913 15.2069 22.8368 14.7586 22.2429 14.4188C21.6497 14.0712 20.9308 13.9 20.0907 13.9C19.5167 13.9 18.9937 13.9816 18.5228 14.1462C18.0533 14.3104 17.6463 14.541 17.3031 14.8389L17.3686 14.9144L17.3032 14.8388C16.965 15.1314 16.7041 15.4771 16.5216 15.8755C16.3387 16.2745 16.2478 16.7086 16.2478 17.1765C16.2478 17.6433 16.3333 18.062 16.5069 18.4303C16.6795 18.7965 16.9277 19.1203 17.2499 19.4015C17.5702 19.681 17.9534 19.9289 18.3985 20.146L18.3994 20.1465C18.8428 20.3573 19.3387 20.5488 19.8868 20.7211L19.8873 20.7212C20.4041 20.8809 20.8281 21.0372 21.1605 21.1898L21.161 21.19C21.4985 21.3427 21.7558 21.5008 21.9372 21.6628L21.9381 21.6637C22.1237 21.8252 22.2488 22.0038 22.3178 22.1991Z" :fill="fill" stroke="white" stroke-width="0.2"/>
  </svg>


</template>

<script>
export default {
  name: 'MoneyCircle',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
